let mapper_options = {
  endpoint: 'allocation_details',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      },
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('allocation_detail', mapper_options)
}